<template>
  <div id="deletedStatus">
    <v-card-title v-if="allowedProfile.includes(this.profile)"
                  class="primary darken-3 py-1 white--text text-body-1 justify-center rounded-lg">
      {{ slotProps.input.label }}
    </v-card-title>
    <slot :source="source"></slot>
  </div>
</template>

<script>
export default {
  name: "fhir-extension",
  props: [
    "field",
    "sliceName",
    "min",
    "max",
    "base-min",
    "base-max",
    "profile",
    "slotProps",
    "path",
    "edit",
    "constraints",
  ],
  data: function () {
    return {
      source: {path: "", data: []},
      errors: [],
      allowedProfile: [
        'http://ihris.org/fhir/StructureDefinition/ihris-practitioner-dependents',
        'http://ihris.org/fhir/StructureDefinition/ihris-practitioner-disability',
        'http://ihris.org/fhir/StructureDefinition/ihris-personal-information-remark-note',
        'http://ihris.org/fhir/StructureDefinition/ihris-practitioner-attachments']
    };
  },
  created: function () {


    this.setupData();
  },
  watch: {
    slotProps: {
      handler() {
        this.setupData();
      },
      deep: true,
    },
  },
  methods: {
    setupData: function () {
      if (this.slotProps && this.slotProps.source) {
        this.source = {
          path: this.slotProps.source.path + "." + this.field,
          data: {},
        };

        if (this.slotProps.source.fromArray) {
          this.source.data = this.slotProps.source.data;
        } else {
          let url;
          if (this.profile) {
            url = this.profile;
          } else {
            url = this.sliceName;
          }

          let expression = this.field.replace(
              /([^:]+):(.+)/,
              "$1.where(url='" + url + "')"
          );

          this.source.data = this.$fhirpath.evaluate(
              this.slotProps.source.data,
              expression
          );
        }
      }
    },
  },
};
</script>
